import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Root = styled.div`
  height: 4px;
  border-radius: var(--unit);
  background-color: var(--c-neutral-400);
`;
const DurationProgress = styled.div`
  height: 100%;
  border-radius: var(--unit);
  background-color: var(--c-neutral-700);
`;

export enum StoryStatus {
  SEEN,
  NOT_SEEN,
}

const INTERVAL = 10;

type Props = {
  playing: boolean;
  duration: number;
  onFinish: () => void;
  storyStatus?: StoryStatus;
  pause?: boolean;
};
export const DurationIndicator = ({
  playing,
  duration,
  onFinish,
  storyStatus,
  pause,
}: Props) => {
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [storyFinished, setStoryFinished] = useState(false);
  const interval = useRef<NodeJS.Timeout | null>(null);

  const stopPlaying = () => {
    if (interval.current) {
      clearInterval(interval.current);
      interval.current = null;
    }
  };

  useEffect(() => {
    if (!interval.current && playing) {
      interval.current = setInterval(() => {
        if (!pause) setTimeElapsed(i => i + INTERVAL / 1000);
      }, INTERVAL);
    }
    if (!playing) {
      stopPlaying();
    }
    return () => stopPlaying();
  }, [pause, playing]);

  useEffect(() => {
    if (playing && timeElapsed >= duration && !storyFinished) {
      setStoryFinished(true);
      stopPlaying();
      setTimeElapsed(0);
      onFinish();
    }
  }, [duration, onFinish, playing, storyFinished, timeElapsed]);

  let width = (timeElapsed * 100) / duration;
  if (storyStatus === StoryStatus.SEEN) {
    width = 100;
  } else if (storyStatus === StoryStatus.NOT_SEEN) {
    width = 0;
  }

  return (
    <Root>
      <DurationProgress style={{ width: `${width}%` }} />
    </Root>
  );
};
